import React from "react";

import { white, lightBlue } from "../../components/base/colors";
import Flex from "../../components/base/flex";
import Text from "../../components/base/text";
import Link from "../../components/base/link";
import Heading from "../../components/base/heading";

const EntryModal = ({ isOpen, setIsOpen, hasSeenModal }) => {
  if (!hasSeenModal && isOpen) {
    const onModalClose = () => {
      sessionStorage.setItem("is-healthcare-professional", true);
      setIsOpen(false);
    };

    return (
      <Flex className="modal-background" zIndex={6}>
        <Flex
          flexDirection="column"
          alignItems="center"
          padding={["43px 37px", "60px 37px 65px", "96px 92px"]}
          maxWidth="1275px"
          width={["100%", "100%", "75%"]}
          backgroundColor={white}
          justifyContent="center"
          textAlign="center"
          role="alertdialog"
          aria-labelledby="modal-title"
        >
          <Text id="modal-title" fontWeight={700} fontSize="30px">
            This site is intended for US healthcare professionals.
          </Text>
          <Heading as="h3" className="entry-modal-title">
            Please confirm you are a us healthcare professional.
          </Heading>
          <Flex
            flexDirection={["column", "column", "row"]}
            justifyContent="space-between"
            width="100%"
          >
            <Link
              as="button"
              variant="solidButtonLightBlue"
              width={["100%", "100%", "calc(50% - 25px)"]}
              fontSize="22px"
              backgroundColor={lightBlue}
              height="unset"
              padding={["13px", "19px", "13px 49px"]}
              marginBottom={["20px", "20px", 0]}
              onClick={onModalClose}
            >
              I am a US healthcare professional
            </Link>
            <Link
              variant="solidButtonTeal"
              width={["100%", "100%", "calc(50% - 25px)"]}
              fontSize="22px"
              href="/"
              textAlign="center"
              height="unset"
              padding={["13px", "13px 49px"]}
              role="button"
            >
              I am not a US healthcare professional
            </Link>
          </Flex>
        </Flex>
      </Flex>
    );
  }

  return null;
};

export default EntryModal;
